/* eslint-disable react/prop-types */
/*
Author: Granite Bagas
*/

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  createStackNavigator,
  CardStyleInterpolators,
} from '@react-navigation/stack';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { isWeb } from '@global/screens';

import { setTitleHeader, setDefaultStackOption } from '@global/helpers';

import HamburgerButton from '@components/navbar/HamburgerButton';
import NotificationSettingButton from '@components/navbar/NotificationSettingButton';
import BackButton from '@components/navbar/BackButton';
import MoreButton from '@components/navbar/MoreButton';

import InventoryScreen from '@/screens/inventory/InventoryScreen';
import InventoryFormScreen from '@/screens/inventory/InventoryFormScreen';
import InventoryDetailScreen from '@/screens/inventory/InventoryDetailScreen';
import InventorySummaryScreen from '@/screens/inventory/InventorySummaryScreen';
import InventorySummaryDetailScreen from '@/screens/inventory/InventorySummaryDetailScreen';

import { showPopup } from '@/store/modal';

const Stack = createStackNavigator();

const InventoryNavigator = ({ navigation }) => {
  const insets = useSafeAreaInsets();
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.auth.user);

  return (
    <Stack.Navigator
      initialRouteName="InventoryScreen"
      screenOptions={(props) => ({
        headerLeft: () => <HamburgerButton {...props} />,
        headerRight: () => <NotificationSettingButton {...props} />,
        ...setDefaultStackOption(insets, CardStyleInterpolators, true),
      })}>
      <Stack.Screen
        name="InventoryScreen"
        component={InventoryScreen}
        options={(props) => {
          let isBack = false;
          let title = 'List Inventory';
          if (props?.route?.params?.titleScreen) {
            isBack = true;
            title = `${title} ${
              !props?.route?.params?.isHome
                ? props.route.params.titleScreen
                : ''
            }`;
          }
          const showFilter = () => {
            dispatch(showPopup({ name: 'showFilter', value: 'inventory' }));
          };
          const goToCreateInventory = () => {
            props.navigation.navigate('InventoryFormScreen');
          };
          const goBack = () => {
            props.navigation.navigate('HomeNavigator');
          };

          const menus = [];

          if (
            [
              'superadmin',
              'sales_admin',
              'branch_head',
              'salesman',
              'spv_logistic',
              'general',
            ].includes(userData?.role?.code)
          ) {
            menus.push({
              type: 'function',
              name: 'Create New Inventory',
              callback: goToCreateInventory,
            });
          }

          menus.push({
            type: 'function',
            name: 'Filter',
            callback: showFilter,
          });
          return {
            title: setTitleHeader(title),
            headerLeft: () =>
              isBack ? (
                <BackButton {...props} onPress={() => goBack()} />
              ) : (
                <HamburgerButton {...props} />
              ),
            headerRight: () =>
              isWeb ? (
                <NotificationSettingButton {...props} />
              ) : (
                <MoreButton menu={menus} {...props} />
              ),
          };
        }}
      />
      <Stack.Screen
        name="InventoryFormScreen"
        component={InventoryFormScreen}
        options={(props) => {
          const route = props.route;
          let title = 'Add Inventory';
          if (route.params && route.params.titleScreen) {
            title = 'Edit Inventory';
          }
          const goBack = () => {
            if (route.params && route.params.titleScreen) {
              props.navigation.navigate('InventoryDetailScreen', route.params);
            } else {
              props.navigation.navigate('HomeNavigator');
            }
          };
          return {
            title: setTitleHeader(title),
            headerLeft: () => (
              <BackButton {...props} onPress={() => goBack()} />
            ),
            headerRight: isWeb
              ? () => <NotificationSettingButton {...props} />
              : false,
          };
        }}
      />
      <Stack.Screen
        name="InventoryDetailScreen"
        component={InventoryDetailScreen}
        options={(props) => {
          const route = props.route;
          let title = 'Inventory Detail';
          if (route?.params?.titleScreen) {
            title = route.params.titleScreen;
          }

          const goBack = () => {
            props.navigation.navigate('InventoryScreen');
          };
          return {
            title: setTitleHeader(title),
            headerLeft: () => (
              <BackButton
                {...props}
                notUseLastRoute={true}
                onPress={() => goBack()}
              />
            ),
            headerRight: () =>
              isWeb ? <NotificationSettingButton {...props} /> : false,
          };
        }}
      />
      <Stack.Screen
        name="InventorySummaryScreen"
        component={InventorySummaryScreen}
        options={(props) => {
          let isBack = false;
          let title = 'Inventory Summary';
          if (props?.route?.params?.titleScreen) {
            isBack = true;
            title = `${title} ${
              !props?.route?.params?.isHome
                ? props.route.params.titleScreen
                : ''
            }`;
          }
          const goBack = () => {
            props.navigation.navigate('HomeNavigator');
          };

          return {
            title: setTitleHeader(title),
            headerLeft: () =>
              isBack ? (
                <BackButton {...props} onPress={() => goBack()} />
              ) : (
                <HamburgerButton {...props} />
              ),
            headerRight: () =>
              isWeb ? <NotificationSettingButton {...props} /> : false,
          };
        }}
      />
      <Stack.Screen
        name="InventorySummaryDetailScreen"
        component={InventorySummaryDetailScreen}
        options={(props) => {
          const route = props.route;
          let title = 'Inventory Summary Detail';
          if (route?.params?.titleScreen) {
            title = route.params.titleScreen;
          }

          const goBack = () => {
            props.navigation.navigate('InventorySummaryScreen');
          };
          return {
            title: setTitleHeader(title),
            headerLeft: () => (
              <BackButton
                {...props}
                notUseLastRoute={true}
                onPress={() => goBack()}
              />
            ),
            headerRight: () =>
              isWeb ? <NotificationSettingButton {...props} /> : false,
          };
        }}
      />
    </Stack.Navigator>
  );
};

export default InventoryNavigator;
